import { fontType, toRem } from '../../styles/functions'
import styled from 'styled-components'

export const PageTitleWrapper = styled.h1`
	color: #354d9e;
	font-size: ${toRem(28)};
	${fontType(0)};
`
